import Dexie, { type EntityTable, type Table } from "dexie";
import { SessionState } from "./types";

export const DB_NAME = "mandarin-flashcards";
export const SETTINGS_ID = "session";

export type SettingsRecord = SessionState & { id: string };

export type CardStatRecord = {
  cardId: string;
  timesCorrect: number;
  timesIncorrect: number;
  lastResult: boolean | null;
  lastSeenAt: number;
  correctStreak: number;
};

export type TestSessionRecord = {
  id: string;
  finishedAt: number;
  filteredLevels: number[];
  cardAmount: number;
  shuffled: boolean;
  correctCount: number;
  incorrectCount: number;
  unansweredCount: number;
  totalCount: number;
};

export type TestAnswerRecord = {
  sessionId: string;
  cardId: string;
  order: number;
  position: number;
  answer: boolean | null;
};

export const db = new Dexie(DB_NAME) as Dexie & {
  settings: EntityTable<SettingsRecord, "id">;
  cardStats: EntityTable<CardStatRecord, "cardId">;
  testSessions: EntityTable<TestSessionRecord, "id">;
  testAnswers: Table<TestAnswerRecord, [string, string]>;
};

db.version(1).stores({
  settings: "id",
  cardStats: "cardId, lastSeenAt",
  testSessions: "id, finishedAt",
  testAnswers: "[sessionId+cardId], sessionId, cardId, position"
});
